import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetDeclaracionJuradaCeseActividadObjetivaByUser = {
  status: number | null;
  statusText: string | null;
};

const useGetDeclaracionJuradaCeseActividadObjetivaByUser = () => {
  const [loadingGetDeclaracionJuradaCeseActividadObjetivaByUser, setLoadingGetDeclaracionJuradaCeseActividadObjetivaByUser] = useState(false);
  const [successGetDeclaracionJuradaCeseActividadObjetivaByUser, setSuccessGetDeclaracionJuradaCeseActividadObjetivaByUser] = useState(false);
  const [errorGetDeclaracionJuradaCeseActividadObjetivaByUser, setErrorGetDeclaracionJuradaCeseActividadObjetivaByUser] = useState<any>(null);
  const [dataGetDeclaracionJuradaCeseActividadObjetivaByUser, setDataDeclaracionJuradaCeseActividadObjetivaByUser] = useState<any>(null);

  const [statusGetDeclaracionJuradaCeseActividadObjetivaByUser, setStatusGetDeclaracionJuradaCeseActividadObjetivaByUser] =
    useState<StatusGetDeclaracionJuradaCeseActividadObjetivaByUser>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apirecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getDeclaracionJuradaCeseActividadObjetivaByUser = async (
    userId: string, expedienteId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetDeclaracionJuradaCeseActividadObjetivaByUser(true);
    setSuccessGetDeclaracionJuradaCeseActividadObjetivaByUser(false);
    setErrorGetDeclaracionJuradaCeseActividadObjetivaByUser(null);

    try {
      const res = await apirecord.getSolicitudDeclaracionJuradaObjetivaByUser(userId, expedienteId);

      setStatusGetDeclaracionJuradaCeseActividadObjetivaByUser({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetDeclaracionJuradaCeseActividadObjetivaByUser(true);
      setDataDeclaracionJuradaCeseActividadObjetivaByUser(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetDeclaracionJuradaCeseActividadObjetivaByUser({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetDeclaracionJuradaCeseActividadObjetivaByUser(err);
      console.error("Error en getDeclaracionJuradaCeseActividadObjetivaByUser:", err);

      throw err;

    } finally {
      setLoadingGetDeclaracionJuradaCeseActividadObjetivaByUser(false);
    }
  };

  return {
    getDeclaracionJuradaCeseActividadObjetivaByUser,
    loadingGetDeclaracionJuradaCeseActividadObjetivaByUser,
    successGetDeclaracionJuradaCeseActividadObjetivaByUser,
    errorGetDeclaracionJuradaCeseActividadObjetivaByUser,
    dataGetDeclaracionJuradaCeseActividadObjetivaByUser,
    statusGetDeclaracionJuradaCeseActividadObjetivaByUser
  };
};

export default useGetDeclaracionJuradaCeseActividadObjetivaByUser;
